import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { BatchStatisticsSchema } from './schemas';

const c = initContract();

export const batchesWorkflowContract = c.router({
  sendDeclarationsToPlda: {
    method: 'POST',
    path: '/batches/:batchId/send-declarations-to-plda',
    pathParams: z.object({ batchId: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
    },
  },
  transitionToInvalidate: {
    method: 'POST',
    path: '/batches/:id/transition-to-invalidate',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
    },
  },
  sendDeclarationsBeGate: {
    method: 'GET',
    path: '/batches/:id/send-declarations-be-gate/:lrn?',
    pathParams: z.object({ id: z.string(), lrn: z.string().optional() }),
    responses: {
      200: z.object({}),
    },
  },
  bulkUpdate: {
    method: 'POST',
    path: '/batches/:id/bulk-update',
    pathParams: z.object({ id: z.string() }),
    body: z.object({ declarationsForUpdate: z.array(z.any()) }),
    responses: {
      200: z.object({}),
    },
  },
  updateStatistics: {
    method: 'POST',
    path: '/batches/:id/update-statistics',
    pathParams: z.object({ id: z.string() }),
    body: z.object({ declarationsIdsForUpdate: z.array(z.string()) }),
    responses: {
      200: z.object({}),
    },
  },
  recountStatistics: {
    method: 'POST',
    path: '/batches/:id/recount-statistics',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({
        data: z.object({
          batchName: z.string(),
          batchId: z.number(),
          statistics: BatchStatisticsSchema,
        }),
      }),
    },
  },
  reassignBatches: {
    method: 'POST',
    path: '/batches/reassign-batches',
    body: z.object({ counters: z.string(), userId: z.string() }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  cleanup: {
    method: 'POST',
    path: '/batches/:id/cleanup',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
    },
  },
});
